import { z } from 'zod';

export const ReputationDisputeFormSchema = z.object({
  disputeText: z.string().min(1, 'Required'),
});

export type ReputationDispute = z.infer<typeof ReputationDisputeFormSchema>;
